import { observable } from 'mobx';
import { Asset, IAsset } from './Asset';
import { DEFAULT_IMAGE_ATTRIBUTE } from '../../constants/DefaultImageAttribute';
import { AssetTypes } from '../../constants/AssetTypes';
import { VideoAsset, IVideoAsset } from './VideoAsset';

export enum ImageSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}

export type IMediaType = IVideoAsset | IAsset;

export interface IMedia {
    small: IAsset[];
    medium: IAsset[];
    large: IAsset[];
    smoosh?: IAsset[];
    model?: IAsset[];
    videos?: IVideoAsset[];
    responsive?: IAsset[];
}

export class Media {
    @observable public small: Asset[] = [];
    @observable public medium: Asset[] = [];
    @observable public large: Asset[] = [];
    @observable public model?: Asset[];
    @observable public smoosh?: Asset[];
    @observable public responsive?: Asset[];
    public videos?: IVideoAsset[];

    public static fromJson(media: IMedia): Media {
        const newMedia = new Media();
        if (!media) {
            return newMedia;
        }

        newMedia.small = (media.small && media.small.map(Asset.fromJson)) || [];
        newMedia.medium = (media.medium && media.medium.map(Asset.fromJson)) || [];
        newMedia.large = (media.large && media.large.map(Asset.fromJson)) || [];
        newMedia.responsive = (media.responsive && media.responsive.map(Asset.fromJson)) || [];
        newMedia.videos =
            (media.videos && media.videos.filter(Media.isEmptyVideo).map(VideoAsset.fromJson)) ||
            [];

        if (media.model) {
            newMedia.model = media.model.map((asset) => {
                asset.assetType = AssetTypes.MODEL;

                return Asset.fromJson(asset);
            });
        }

        if (media.smoosh) {
            newMedia.smoosh = media.smoosh.map((asset) => {
                asset.assetType = AssetTypes.SMOOSH;

                return Asset.fromJson(asset);
            });
        }

        return newMedia;
    }

    public getDefaultMedia(size: string, isAlternateImg: boolean = false): IAsset {
        switch (size) {
            case ImageSizes.Small:
                return isAlternateImg && this.small.length > 1
                    ? this.small[1]
                    : this.small[0] || {};
            case ImageSizes.Medium:
                return isAlternateImg && this.medium.length > 1
                    ? this.medium[1]
                    : this.medium[0] || {};
            case ImageSizes.Large:
                return isAlternateImg && this.large.length > 1
                    ? this.large[1]
                    : this.large[0] || {};
            default:
                return DEFAULT_IMAGE_ATTRIBUTE;
        }
    }

    private static isEmptyVideo(videoItem: IVideoAsset) {
        return !!videoItem.src;
    }
}
